import en from "./staff-advances.en.json";
import ar from "./staff-advances.ar.json";

// Advance form's dynamically composed validation sentences are not in the
// existing prototype extraction. Keep these bilingual fragments local to Staff.
export function advanceText(key:keyof typeof en,rtl:boolean,values:Record<string,string|number>={}) {
  return (rtl?ar:en)[key].replace(/\{(\w+)\}/g,(_,name)=>String(values[name]??""));
}
